import { render, staticRenderFns } from "./SyPanel.vue?vue&type=template&id=2415d01c&scoped=true&"
import script from "./SyPanel.vue?vue&type=script&lang=js&"
export * from "./SyPanel.vue?vue&type=script&lang=js&"
import style0 from "./SyPanel.vue?vue&type=style&index=0&id=2415d01c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2415d01c",
  null
  
)

export default component.exports